import React from "react";
const HeaderDriven = () => {


  
  return (
    <div className="container-fluid">
    <div className="row">
      <div className="col-lg-4 mt-2 mb-2">
        <div className="from-group">
          <div className="input-group">
            <input
              id="name"
              name="name"
              type="text"
              maxLength={500}
              placeholder="ชื่อ สกุล"
              className="form-control"
              defaultValue
            />
            <div className="input-group-addon input-group-button col-auto  px-1">
              <button
                type="button"
                id="show-contact-modal-button"
                className="btn btn-primary"
              >
                ค้นหา
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-4 mt-2 mb-2">
        <ul className="btn-group p-0 m-0 ">
          <button type="button" value={0} className="btn btn-primary">
            All
          </button>
          <button type="button" value={1} className="btn btn-outline-dark">
            รถขึ้นแท่นชั่ง
          </button>
          <button type="button" value={2} className="btn btn-outline-dark">
            รถเข้า-ออกทางฉุกเฉิน
          </button>
        </ul>
      </div>
   
    </div>
    <div className="row">
    <div className="col-lg-2 mt-2 mb-4">
        <div className="card">
          <button className="btn btn-primary " type="button">
          <i className="bi bi-plus-lg me-2" />
            ADD NEW
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDriven;
